'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import ResourceCenterContent from './components/ResourceCenterContent';

export default function ResourcesPage() {
  return (
    <AppLayout title="Resource Center">
      <ResourceCenterContent />
    </AppLayout>
  );
}
